import { render, staticRenderFns } from "./Move.vue?vue&type=template&id=02dc2a5a&scoped=true&"
import script from "./Move.vue?vue&type=script&lang=js&"
export * from "./Move.vue?vue&type=script&lang=js&"
import style0 from "./Move.vue?vue&type=style&index=0&id=02dc2a5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dc2a5a",
  null
  
)

/* custom blocks */
import block0 from "./Move.vue?vue&type=custom&index=0&blockType=i18nf"
if (typeof block0 === 'function') block0(component)

export default component.exports